import { closeModal } from "app/slices/modalSlice";

import { useTranslation } from "react-i18next";
import { Button, ControlledSelectGray } from "components/Shared";
import { useDispatch } from "react-redux";

import { toast } from "sonner";
import { Controller, useForm } from "react-hook-form";

import { Plus as Add } from "lucide-react";
import useErrorListener from "hooks/useErrorListener";
import { WebhookCreate } from "interfaces/router";
import { ValidEvents } from "interfaces/enums";
import { useCreateWebhookMutation } from "api/institutional/router_api";
import { urlPattern } from "utils/numberUtils";
import {
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";

export const CreateWebhook = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(closeModal());
  };

  const {
    handleSubmit,
    register,
    control,
    formState: { isValid },
  } = useForm<WebhookCreate>();

  const [mutate, { error, isLoading }] = useCreateWebhookMutation();

  useErrorListener({ error });

  const doSubmit = (values: WebhookCreate) => {
    mutate(values);
    toast.success(t("New Webhook created"));
    handleClose();
  };

  return (
    <DialogContent>
      <DialogHeader>
        <DialogTitle>{t("Create New Webhook")}</DialogTitle>
      </DialogHeader>
      <form onSubmit={handleSubmit(doSubmit)} className="flex flex-col gap-2">
        <span className="text-sm">
          {t(
            "Specify the URL for event delivery and choose the events you want to listen for",
          )}
          .
        </span>
        <Input
          placeholder="https://mywebhook.com/event"
          {...register("url", { required: true, pattern: urlPattern })}
        />
        <Controller
          name="events"
          rules={{
            required: true,
          }}
          control={control}
          render={(renderProps) => (
            <ControlledSelectGray
              placeholder={t("Select events")}
              renderProps={renderProps}
              isMulti={true}
              options={[ValidEvents["order.updated"]]}
            />
          )}
        />

        <Button
          className="w-full "
          type="submit"
          disabled={isLoading || !isValid}
        >
          <Add />
          {t("Create Webhook")}
        </Button>
      </form>
    </DialogContent>
  );
};

export default CreateWebhook;
